import './assets/css/styles.scss';
import ItemCarousel from "./components/ItemCarousel";
import AuctionGuide from "./components/AuctionGuide";
import RegisterBanner from "./components/RegisterBanner";
import HomeNews from "./components/HomeNews";
import { useLazyGetClientAuctionListQuery } from "../auction/redux/AuctionApi";
import { useEffect } from "react";
import { StartStatus } from "../auction/types";
import HomeSearch from './components/HomeSearch';
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useAppDispatch } from "../../redux/Hooks";
import { toggleLoginModal, logout, setUser, setTempEmail, setUnsuccessfulGoogleError } from "../login/redux/LoginSlice";
import { toggleRegisterModal } from "../register/redux/RegisterSlice";
import { useState } from 'react'
import { isTokenExpired } from '../common/ts/CommonFunctions'
import ConfirmModal from "../common/components/ConfirmModal";
import { useLazyGetGoogleTokenQuery } from "../../redux/api/PublicApi";
import { useLazyGetUserInfoQuery, useLazyVerifyAccountQuery } from "../../redux/api/AccountApi";
import { notification } from 'antd';

const Home = () => {
    const [upcomingTrigger, upcomingResponse] = useLazyGetClientAuctionListQuery();
    const [ongoingTrigger, ongoingResponse] = useLazyGetClientAuctionListQuery();
    const [verifyAccount] = useLazyVerifyAccountQuery();
    const dispatch = useAppDispatch();
    const navigate = useNavigate()
    const [visible, setVisible] = useState(false);
    const [errorVisible, setErrorVisible] = useState(false);
    let [searchParams] = useSearchParams()
    let code = searchParams.get("code");
    let token = searchParams.get("token");
    const params = useParams();
    // let token = searchParams.get("token")
    const [trigger] = useLazyGetGoogleTokenQuery()
    let userToken = localStorage.getItem("accessToken")
    const [getUserInfo] = useLazyGetUserInfoQuery();
    const URI = process.env.REACT_APP_BASE_API_URL;
    // const URI = "http://localhost:3000"
    const OVERTIME_MESSAGE = "Đã hết thời gian kích hoạt tài khoản, vui lòng thực hiện lại."
    const MESSAGE = "Xác thực thất bại"

    const [numOfItems, setNumOfItems] = useState(4);

    useEffect(() => {
        const setNumOfItemsOnBreakpoint = (breakpoint: number) => {
            if (breakpoint >= 1700) {
                setNumOfItems(4);
            } else if (breakpoint < 1700 && breakpoint >= 1300) {
                setNumOfItems(3);
            } else if (breakpoint < 1300 && breakpoint >= 1100) {
                setNumOfItems(2);
            } else {
                setNumOfItems(1);
            }
        }

        setNumOfItemsOnBreakpoint(window.innerWidth);

        window.addEventListener("resize", () => {
            setNumOfItemsOnBreakpoint(window.innerWidth)
        })
    }, [])

    useEffect(() => {
        if (params?.token || token) {
            let verifyToken = params?.token || token || '';
            if (userToken && !isTokenExpired(userToken)) {
                dispatch(logout());
            }
            navigate("/")
            verifyAccount(verifyToken).unwrap().then(() => {
                dispatch(toggleLoginModal());
                toggleVisible()
            })
                .catch((err) => {
                    if (err.data?.message === MESSAGE) {
                        dispatch(toggleLoginModal())
                    }
                    if (err.data?.message === OVERTIME_MESSAGE) {
                        dispatch(toggleRegisterModal())
                        toggleError()
                    }
                })
        }
    }, [params.token, dispatch, navigate, token, userToken, verifyAccount])

    useEffect(() => {
        upcomingTrigger({
            page: 0,
            size: 6,
            status: 124,
            type: 0,
            startStatus: StartStatus.UPCOMING,
        })

        ongoingTrigger({
            page: 0,
            size: 6,
            status: 124,
            type: 0,
            startStatus: StartStatus.ONGOING,
        })
    }, [upcomingTrigger, ongoingTrigger])

    //đăng nhập bằng google, thay uri bằng localhost nếu muốn test bên localhost
    useEffect(() => {
        if (code !== null) {
            if (userToken && !isTokenExpired(userToken)) {
                dispatch(logout());
            }
            navigate("/")
            trigger({ redirect_uri: URI, code: code }).unwrap().then((res) => {
                if (res.accessToken !== null) {
                    localStorage.removeItem("accessToken");
                    localStorage.setItem("accessToken", res.accessToken);
                    getUserInfo({}).unwrap().then(res => {
                        dispatch(setUser(res))
                    }).catch(err => {
                        notification.error({ message: err.data?.message || "Không lấy được thông tin cá nhân!" });
                        dispatch(logout());
                        navigate("/");
                    })
                }
                else {
                    dispatch(setTempEmail(res.email))
                    dispatch(toggleRegisterModal())
                }
            })
                .catch(err => {
                    dispatch(setUnsuccessfulGoogleError(err.data?.message || 'Đăng nhập bằng Google không thành công!'))
                    dispatch(toggleLoginModal())
                })
        }
    }, [code, trigger])

    const toggleVisible = () => {
        setVisible(!visible);
    }

    const toggleError = () => {
        setErrorVisible(!errorVisible);
    }

    return (
        <div style={{ background: "#e5e5e5", display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <HomeSearch />
            <div style={{ position: 'relative', textAlign: 'center' }}>
                <div className="section-banner" style={{ marginTop: 40, color: 'black' }}>TÀI SẢN SẮP ĐƯỢC ĐẤU GIÁ</div>

                {upcomingResponse.data?.totalElements && upcomingResponse.data?.totalElements > numOfItems ?
                    <div
                        style={{ fontSize: 16, position: 'absolute', left: '100%', bottom: -5, whiteSpace: 'nowrap' }}
                        className="anchor-text"
                        onClick={() => navigate("/auction-list/upcoming")}>
                        Xem thêm
                    </div>
                    : <></>}
            </div>
            <ItemCarousel
                numOfItems={numOfItems}
                emptyMessage='Hiện không có tài sản sắp được đấu giá'
                key="upcoming"
                items={upcomingResponse.data?.content || []}
                totalElements={upcomingResponse.data?.totalElements || 0}
                reloadPage={() => upcomingTrigger({
                    page: 0,
                    size: 6,
                    status: 124,
                    type: 0,
                    startStatus: StartStatus.UPCOMING
                })} />

            <div style={{ position: 'relative', textAlign: 'center' }}>
                <div className="section-banner" style={{ marginTop: 40, color: 'black' }}>TÀI SẢN ĐANG ĐƯỢC ĐẤU GIÁ</div>
                {ongoingResponse.data?.totalElements && ongoingResponse.data?.totalElements > numOfItems ?
                    <div
                        style={{ fontSize: 16, position: 'absolute', left: '100%', bottom: -5, whiteSpace: 'nowrap' }}
                        className="anchor-text"
                        onClick={() => navigate("/auction-list/ongoing")}>
                        Xem thêm
                    </div>
                    : <></>}
            </div>
            <ItemCarousel
                numOfItems={numOfItems}
                key="ongoing"
                items={ongoingResponse.data?.content || []}
                totalElements={ongoingResponse.data?.totalElements || 0}
                reloadPage={() => ongoingTrigger({
                    page: 0,
                    size: 6,
                    status: 124,
                    type: 0,
                    startStatus: StartStatus.ONGOING
                })} />

            <AuctionGuide />

            <RegisterBanner />

            <div className="section-banner" style={{ marginTop: 40, color: 'black' }}>Tin tức - Sự kiện</div>
            <HomeNews />

            {visible ?
                <ConfirmModal
                    visible={visible}
                    status="success"
                    onOk={toggleVisible}
                    onCancel={toggleVisible}
                    noCancelButton
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">Kích hoạt tài khoản thành công!</div>
                    </div>}
                /> : <></>}

            {errorVisible ?
                <ConfirmModal
                    visible={errorVisible}
                    status="error"
                    onOk={toggleError}
                    onCancel={toggleError}
                    noCancelButton
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">{OVERTIME_MESSAGE}</div>
                    </div>}
                /> : <></>}
        </div>
    )
}

export default Home;